export class ResetPasswordConfirmRequest {
    constructor(
        public token: string,
        public new_password: string,
        public confirm_password: string
    ){}
}
